import React from 'react';
import ThisProject from '../ThisProject';

const Content = () => {

  return (
    <ThisProject>
      {({ thisProject, projectId, prLink }) => (
        <div className='projectContent'>
          {thisProject.client}
        </div>
      )}
    </ThisProject>
  )
}

export default Content